import React from "react";

const stages = [
  { stage: "Stage 1", desc: "Marketplace" },
  { stage: "Stage 2", desc: "Digital Twins" },
  { stage: "Stage 3", desc: "Make Friends, Talk, Chat, Collect Goodies / Gifts" },
  { stage: "Stage 4", desc: "Smart Contracts, Trade Virtually" },
  { stage: "Stage 5", desc: "AI enabled Remote Quality Check" },  
  { stage: "Stage 6", desc: "Immersive AR/VR Farming" },
];

const SyntraMetaverseStageTimeline = () => (
  <div className="mt-16 max-w-3xl mx-auto">
    <h2 className="text-2xl font-bold text-green-900 mb-6">🚀 Roadmap</h2>
    <div className="space-y-4">
      {stages.map((s, i) => (
        <div key={i} className="bg-white shadow p-4 rounded-lg">
          <h3 className="font-bold text-green-800">{s.stage}</h3>
          <p className="text-green-600">{s.desc}</p>
        </div>
      ))}
    </div>
  </div>
);

export default SyntraMetaverseStageTimeline;
